import { enqueueSnackbar } from '@/providers';
import { useState } from 'react';
import { Area } from 'react-easy-crop';
import { SNACKBAR_VARIANT } from '@/constants/notifications';

export const ACCEPTED_FILE_EXTENSIONS = ['.jpeg', '.jpg', '.png'];
const DEFAULT_CROP = { x: 0, y: 0 };
const DEFAULT_ZOOM = 1;
const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
export const MAX_FILE_SIZE_MB = '25MB';

export function useImageCropper() {
  const [previewImage, setPreviewImage] = useState<string>();
  const [crop, setCrop] = useState(DEFAULT_CROP);
  const [zoom, setZoom] = useState(DEFAULT_ZOOM);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area>();

  const onCropComplete = (_croppedArea: Area, croppedAreaPixels: Area) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const onSelectImage = (file?: File | null) => {
    if (!file) return;
    if (file.size > MAX_FILE_SIZE_BYTES) {
      enqueueSnackbar(
        `File too large. Max allowed size is ${MAX_FILE_SIZE_MB}`,
        { variant: SNACKBAR_VARIANT.ERROR },
      );
      return;
    }
    if (!ACCEPTED_FILE_EXTENSIONS.some((ext) => file.name.endsWith(ext))) {
      enqueueSnackbar(
        `Invalid file type. Allowed types are: ${ACCEPTED_FILE_EXTENSIONS.join(
          ', ',
        )}`,
        { variant: SNACKBAR_VARIANT.ERROR },
      );
      return;
    }

    setPreviewImage(URL.createObjectURL(file));
  };

  const onReset = () => {
    setPreviewImage('');
    setCrop(DEFAULT_CROP);
    setZoom(DEFAULT_ZOOM);
    setCroppedAreaPixels(undefined);
  };

  return {
    previewImage,
    setPreviewImage,
    crop,
    setCrop,
    zoom,
    setZoom,
    croppedAreaPixels,
    setCroppedAreaPixels,
    onCropComplete,
    onSelectImage,
    onReset,
  };
}
